import { render, staticRenderFns } from "./PausedDraw.vue?vue&type=template&id=badbae54&scoped=true"
import script from "./PausedDraw.vue?vue&type=script&lang=js"
export * from "./PausedDraw.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=badbae54&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badbae54",
  null
  
)

export default component.exports